import {
    Directive,
    ElementRef,
    Input,
    Renderer2,
    AfterViewInit,
    OnDestroy
  } from '@angular/core';
  
  @Directive({
    selector: '[ariaInjector]'
  })
  export class AriaInjectorDirective implements AfterViewInit, OnDestroy {
    @Input('ariaInjector') configs!: Array<{
      selector: string;
      [key: string]: any;
    }>;
  
    private observer!: MutationObserver;
  
    constructor(private el: ElementRef, private renderer: Renderer2) {}
  
    ngAfterViewInit(): void {
      this.applyAriaAttributes();
  
      // Watch for changes inside the component
      this.observer = new MutationObserver(() => {
        this.applyAriaAttributes();
      });
  
      this.observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true,
      });
    }
  
    private applyAriaAttributes(): void {
      if (!Array.isArray(this.configs)) return;
  
      for (const config of this.configs) {
        const selector = config.selector;
        if (!selector) continue;
  
        const targetEls = this.el.nativeElement.querySelectorAll(selector);
        if (!targetEls.length) {
          console.warn(`[ariaInjector] No elements found for selector: ${selector}`);
          continue;
        }
  
        targetEls.forEach((targetEl: any) => {
          Object.entries(config).forEach(([key, value]) => {
            if (key === 'selector' || value == null) return;
  
            // Convert camelCase to kebab-case
            const attrName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
            this.renderer.setAttribute(targetEl, attrName, value);
          });
        });
      }
    }
  
    ngOnDestroy(): void {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  